import { Cup, CupSize, CupVariant } from 'root/src/client/web/giveaway/components/Cup';
import { ModalLayout } from 'root/src/client/v2/common/layouts/ModalLayout';
import { ButtonNew } from 'root/src/client/v2/common/components/form/ButtonNew';
import { useModal } from 'root/src/client/v2/common/contexts/modal.context';
import { useCreatorActiveGiveaway } from 'root/src/client/web/giveaway/hooks/useCreatorGiveaways';
import { ActionStrategyId } from '@daredrop-com/rewards-api-contract';
import { useAuthentication } from 'root/src/client/v2/auth/hooks/useAuthentication';
export const AutoEnteredGiveawayModal = () => {
    var _a;
    const { authentication } = useAuthentication();
    const modal = useModal();
    const giveaway = useCreatorActiveGiveaway();
    const hasEntries = (_a = giveaway === null || giveaway === void 0 ? void 0 : giveaway.actions) === null || _a === void 0 ? void 0 : _a.some((action) => {
        if (!authentication) {
            return false;
        }
        if (action.strategyId !== ActionStrategyId.EnterGiveawayTwitch
            && action.strategyId !== ActionStrategyId.EnterGiveawayTwitchSubscription
            && action.strategyId !== ActionStrategyId.EnterGiveawayYoutube) {
            return false;
        }
        return action.entries.some(entry => entry.participantId === authentication.userId);
    });
    return (<ModalLayout>
			<h1 className="font-bold text-2xl font-mono text-center">You entered to the Giveaway!</h1>
			<Cup size={CupSize.XL} variant={CupVariant.Silver}/>
			<p className="text-light-4 text-center">
				{hasEntries ? 'We wish you the best of luck in the giveaway!' : 'Now subscribe to the creator channels to increase your chance to win!'}
			</p>
			<ButtonNew onClick={modal.hide}>Got It!</ButtonNew>
		</ModalLayout>);
};
